import styled from 'vue-styled-components'
const ReHeight = styled.div`
pointer-events: all;
  position: absolute;
  width: 96px;
  height: 10px;
  background-color: #FFFFFF;
  border: 1px solid #12A9FF;
  border-radius: 0px 0px 10px 10px;
  bottom: -9px;
  box-shadow: 1px 1px #0000004f;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 1;
  max-width: 100%;
  cursor: row-resize;
`
const ToolLabel = styled.div`
  position: absolute;
  background-color: #12A9FF;
  color: #ffffff;
  height: 25px;
  width: fit-content;
  top: 5px;
  left: 100%;
  border-radius: 4px;
`
export {
  ReHeight,
  ToolLabel
}